<template>
  <NavbarLayout />
  <SidebarLayout v-if="userData != null" />
  <v-main id="content">
    <div
      class="w-100 min-vh-100"
      :style="{
        backgroundImage:
          'linear-gradient(rgba(255, 255, 255, 0.2),rgba(0, 0, 0, 0.75)),url(' +
          require('@/assets/images/penghargaan_new.jpg') +
          ')',
        backgroundSize: 'cover',
      }"
    >
      <v-container>
        <div class="flex flex-col justify-center h-screen gap-2 -mt-12">
          <h1 class="font-bold font-inter text-5xl text-white">
            Our Achievement
          </h1>
          <div class="w-80">
            <p class="text-white text-base font-normal">
              Sejumlah penghargaan yang telah kami terima dengan bangga sebagai
              pengakuan terhadap komitmen kami terhadap kualitas dan inovasi.
            </p>
          </div>
        </div>
      </v-container>
      <!-- <h1 class="font-bold font-inter text-4xl">Our Achievement</h1>
          <div class="w-50">
            <p class="stext">
              Sejumlah penghargaan yang telah kami terima dengan bangga sebagai
              pengakuan terhadap komitmen kami terhadap kualitas dan inovasi.
            </p>
          </div>
        </div> -->
      <!-- </div>  -->
    </div>
    <div class="background-white w-100 min-vh-100 py-5">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div
              :style="{ backgroundColor: '#DD3838', height: '3px' }"
              class="w-15 mb-4"
            >
              &nbsp;
            </div>
            <h1 class="htext">Pretasi & Penghargaan</h1>
            <p class="sbtext">
              Sejumlah penghargaan yang telah kami terima dengan bangga sebagai
              pengakuan terhadap komitmen kami terhadap kualitas dan inovasi.
              Setiap penghargaan mewakili hasil dari kerja tim yang gigih dan
              tekad kami untuk mencapai standar keunggulan dalam setiap yang
              kami lakukan.
            </p>
          </v-col>
        </v-row>
        <v-row class="mt-5">
          <v-col cols="6" sm="4">
            <div
              class="w-100"
              :style="{
                background:
                  'url(' +
                  require('../assets/images/Penghargaan/2022_Piagam_P2_Covid-19_Gold-1.png') +
                  ') no-repeat center',
                height: '30vh',
                'background-size': 'contain',
              }"
            ></div>
            <div class="p-2 shadow-sm p-3 mb-5 bg-body rounded">
              <p class="title_penghargaan">Penghargaan Penanganan Covid-19</p>
              <p class="time_penghargaan">
                <font-awesome-icon icon="fa-solid fa-clock" /> 13 Mei 2022
              </p>
            </div>
          </v-col>
          <v-col cols="6" sm="4">
            <div
              class="w-100"
              :style="{
                background:
                  'url(' +
                  require('../assets/images/Penghargaan/2022_Piagam_P2_Covid-19_Gold-2.png') +
                  ') no-repeat center',
                height: '30vh',
                'background-size': 'contain',
              }"
            ></div>
            <div class="p-2 shadow-sm p-3 mb-5 bg-body rounded">
              <p class="title_penghargaan">Penghargaan Penanganan Covid-19</p>
              <p class="time_penghargaan">
                <font-awesome-icon icon="fa-solid fa-clock" /> Februari 2022
              </p>
            </div>
          </v-col>
          <v-col cols="6" sm="4">
            <div
              class="w-100"
              :style="{
                background:
                  'url(' +
                  require('../assets/images/Penghargaan/20221229_Piala_Proper_Hijau_PT_BIB.jpg') +
                  ') no-repeat center',
                height: '30vh',
                'background-size': 'contain',
              }"
            ></div>
            <div class="p-2 shadow-sm p-3 mb-5 bg-body rounded">
              <p class="title_penghargaan">Piala Proper Hijau</p>
              <p class="time_penghargaan">
                <font-awesome-icon icon="fa-solid fa-clock" /> 2022
              </p>
            </div>
          </v-col>
          <v-col cols="6" sm="4">
            <div
              class="w-100"
              :style="{
                background:
                  'url(' +
                  require('../assets/images/Penghargaan/GMP_2022_Aditama_Kelola_Lingkungan.jpeg') +
                  ') no-repeat center',
                height: '30vh',
                'background-size': 'contain',
              }"
            ></div>
            <div class="p-2 shadow-sm p-3 mb-5 bg-body rounded">
              <p class="title_penghargaan">Aditama Kelola Lingkungan</p>
              <p class="time_penghargaan">
                <font-awesome-icon icon="fa-solid fa-clock" /> 29 September 2022
              </p>
            </div>
          </v-col>
          <v-col cols="6" sm="4">
            <div
              class="w-100"
              :style="{
                background:
                  'url(' +
                  require('../assets/images/Penghargaan/GMP2022AditamaTeknisPertambangan.jpeg') +
                  ') no-repeat center',
                height: '30vh',
                'background-size': 'contain',
              }"
            ></div>
            <div class="p-2 shadow-sm p-3 mb-5 bg-body rounded">
              <p class="title_penghargaan">Aditama Teknis Pertambangan</p>
              <p class="time_penghargaan">
                <font-awesome-icon icon="fa-solid fa-clock" /> 29 September 2022
              </p>
            </div>
          </v-col>
          <v-col cols="6" sm="4">
            <div
              class="w-100"
              :style="{
                background:
                  'url(' +
                  require('../assets/images/Penghargaan/TrophyGMPAwardKategoriIUP_PKP2B.jpeg') +
                  ') no-repeat center',
                height: '30vh',
                'background-size': 'contain',
              }"
            ></div>
            <div class="p-2 shadow-sm p-3 mb-5 bg-body rounded">
              <p class="title_penghargaan">GMP Award Kategori IUP PKP2B</p>
              <p class="time_penghargaan">
                <font-awesome-icon icon="fa-solid fa-clock" /> 2022
              </p>
            </div>
          </v-col>
          <v-col cols="6" sm="4">
            <div
              class="w-100"
              :style="{
                background:
                  'url(' +
                  require('../assets/images/Penghargaan/2022PiagamP2HIV-AIDSSilver-1.png') +
                  ') no-repeat center',
                height: '30vh',
                'background-size': 'contain',
              }"
            ></div>
            <div class="p-2 shadow-sm p-3 mb-5 bg-body rounded">
              <p class="title_penghargaan">Penghargaan Pencegahan HIV AIDS</p>
              <p class="time_penghargaan">
                <font-awesome-icon icon="fa-solid fa-clock" /> 13 Mei 2022
              </p>
            </div>
          </v-col>
          <v-col cols="6" sm="4">
            <div
              class="w-100"
              :style="{
                background:
                  'url(' +
                  require('../assets/images/Penghargaan/2022PiagamP2HIV-AIDSSilver-2.png') +
                  ') no-repeat center',
                height: '30vh',
                'background-size': 'contain',
              }"
            ></div>
            <div class="p-2 shadow-sm p-3 mb-5 bg-body rounded">
              <p class="title_penghargaan">Penghargaan Pencegahan HIV AIDS</p>
              <p class="time_penghargaan">
                <font-awesome-icon icon="fa-solid fa-clock" /> Februari 2022
              </p>
            </div>
          </v-col>
          <v-col cols="6" sm="4">
            <div
              class="w-100"
              :style="{
                background:
                  'url(' +
                  require('../assets/images/Penghargaan/2022PiagamZeroAccidentAward-1.png') +
                  ') no-repeat center',
                height: '30vh',
                'background-size': 'contain',
              }"
            ></div>
            <div class="p-2 shadow-sm p-3 mb-5 bg-body rounded">
              <p class="title_penghargaan">Zero Accident Award</p>
              <p class="time_penghargaan">
                <font-awesome-icon icon="fa-solid fa-clock" /> 2022
              </p>
            </div>
          </v-col>
          <v-col cols="6" sm="4">
            <div
              class="w-100"
              :style="{
                background:
                  'url(' +
                  require('../assets/images/Penghargaan/2022PiagamZeroAccidentAward-2.png') +
                  ') no-repeat center',
                height: '30vh',
                'background-size': 'contain',
              }"
            ></div>
            <div class="p-2 shadow-sm p-3 mb-5 bg-body rounded">
              <p class="title_penghargaan">Zero Accident Award</p>
              <p class="time_penghargaan">
                <font-awesome-icon icon="fa-solid fa-clock" /> 2022
              </p>
            </div>
          </v-col>
          <v-col cols="6" sm="4">
            <div
              class="w-100"
              :style="{
                background:
                  'url(' +
                  require('../assets/images/Penghargaan/GMP2022UtamaKeselamatan-1.png') +
                  ') no-repeat center',
                height: '30vh',
                'background-size': 'contain',
              }"
            ></div>
            <div class="p-2 shadow-sm p-3 mb-5 bg-body rounded">
              <p class="title_penghargaan">Penghargaan Utama Keselamatan</p>
              <p class="time_penghargaan">
                <font-awesome-icon icon="fa-solid fa-clock" /> 29 September 2022
              </p>
            </div>
          </v-col>
          <v-col cols="6" sm="4">
            <div
              class="w-100"
              :style="{
                background:
                  'url(' +
                  require('../assets/images/Penghargaan/GMP2022UtamaKonservasi-1.png') +
                  ') no-repeat center',
                height: '30vh',
                'background-size': 'contain',
              }"
            ></div>
            <div class="p-2 shadow-sm p-3 mb-5 bg-body rounded">
              <p class="title_penghargaan">Penghargaan Utama Konservasi</p>
              <p class="time_penghargaan">
                <font-awesome-icon icon="fa-solid fa-clock" /> 29 September 2022
              </p>
            </div>
          </v-col>
          <v-col cols="6" sm="4">
            <div
              class="w-100"
              :style="{
                background:
                  'url(' +
                  require('../assets/images/Penghargaan/GMP2022UtamaStandarisasiUsahaJasa-1.png') +
                  ') no-repeat center',
                height: '30vh',
                'background-size': 'contain',
              }"
            ></div>
            <div class="p-2 shadow-sm p-3 mb-5 bg-body rounded">
              <p class="title_penghargaan">
                Penghargaan Utama Standarisasi Usaha Jasa
              </p>
              <p class="time_penghargaan">
                <font-awesome-icon icon="fa-solid fa-clock" /> 29 September 2022
              </p>
            </div>
          </v-col>
          <v-col cols="6" sm="4">
            <div
              class="w-100"
              :style="{
                background:
                  'url(' +
                  require('../assets/images/Penghargaan/SertifikasiISO14001_45001-1.png') +
                  ') no-repeat center',
                height: '30vh',
                'background-size': 'contain',
              }"
            ></div>
            <div class="p-2 shadow-sm p-3 mb-5 bg-body rounded">
              <p class="title_penghargaan">Sertifikasi ISO 14001 - 45001</p>
              <p class="time_penghargaan">
                <font-awesome-icon icon="fa-solid fa-clock" /> 2 November 2021
              </p>
            </div>
          </v-col>
          <v-col cols="6" sm="4">
            <div
              class="w-100"
              :style="{
                background:
                  'url(' +
                  require('../assets/images/Penghargaan/PenghargaanMenteriKeseharanRI.jpeg') +
                  ') no-repeat center',
                height: '30vh',
                'background-size': 'contain',
              }"
            ></div>
            <div class="p-2 shadow-sm p-3 mb-5 bg-body rounded">
              <p class="title_penghargaan">Pengahargaan Menteri Kesehatan</p>
              <p class="time_penghargaan">
                <font-awesome-icon icon="fa-solid fa-clock" /> 2 November 2021
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-main>
</template>
<style scoped>
.py-10 {
  padding: 10rem;
}
.w-15 {
  width: 15%;
}
.w-38 {
  width: 38%;
}
.w-55 {
  width: 55%;
}

.btext {
  font-size: 4rem;
  font-family: "Inter-Black";
  color: #ffffff;
  line-height: 4.5rem;
}

.stext {
  font-size: 1.2rem;
  font-family: "Inter-Bold";
  color: #dcdcdc;
  line-height: 1.25rem;
}

h1.htext {
  font-size: 2.5rem;
  font-family: "Inter-Bold";
  color: #28293d;
  line-height: 3rem;
}
.sbtext {
  font-size: 1rem;
  font-family: "Inter-SemiBold";
  color: #999aa9;
  line-height: 1.25rem;
}
.title_penghargaan {
  color: #28293d;
  font-size: 1.2rem;
  font-family: "Inter-SemiBold";
}

.time_penghargaan {
  font-size: 1rem;
  color: #555770;
  font-family: "Inter-Regular";
}

.pgn {
  padding: 0.25em 0.7em;
  margin: 0 0.25em;
}
.pgn-active {
  background-color: #dd3737 !important;
  color: #ffffff;
}
</style>
<script>
import NavbarLayout from "@/layouts/NavbarLayout.vue";
import GlobalDataMixin from "../GlobalDataMixin";
import SidebarLayout from "@/layouts/SidebarLayout.vue";

export default {
  mixins: [GlobalDataMixin],
  name: "PenghargaanPage",
  metaInfo() {
    return {
      title: "Home",
    };
  },
  components: { NavbarLayout, SidebarLayout },
  computed: {
    colClass() {
      return this.userData == null ? "col-md-12" : "col-md-10 col-lg-10";
    },
  },
};
</script>
